module.exports = __webpack_public_path__ + "img/desktop_results.84dcaa9d.jpg";